import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Dollars } from '@local/do-secundo-dollars'

import { useDeliveryToasts } from './use-delivery-toasts'
import { useLineItems } from '../../../utils/cart-helpers'
import { TermsModal, CHARGE_INFO } from '@local/do-secundo-terms-modal'
import { useFlag, FF } from '@local/do-secundo-feature-flag'
import { InfoIcon } from '@toasttab/buffet-pui-icons'
import styles from './CartFooter.module.css'

export const CartFooter = ({
  cart,
  deliveryChargeLabel = 'Delivery Cost',
  showTotal = false,
  showTip = false,
  tip = null,
  showRoundUp = false,
  roundUp = null
}) => {
  const [showChargeModal, setShowChargeModal] = useState(false)
  const SHOW_CHARGE_INFO_ENABLED = useFlag(FF.SHOW_CHARGE_INFO)

  const getLineItems = useLineItems({
    cart,
    showTip,
    showTotal,
    showRoundUp,
    deliveryChargeLabel
  })

  useDeliveryToasts({ cart })
  const lineItems = getLineItems(tip, roundUp)
  return (
    <>
      {showChargeModal && (
        <TermsModal
          onClose={() => setShowChargeModal(false)}
          terms={CHARGE_INFO}
        />
      )}
      <div
        className={cx(styles.footer, 'type-default')}
        data-testid='total-amounts'
        role='group'
        aria-label='cart totals'
      >
        <table>
          <tfoot>
            {lineItems.map(({ label, amount, id }) => {
              const showServiceChargeInfoIcon =
                (id === 'Service-charge-amount' || // takeout fee
                  id === 'deliveryChargeTotal-amount') &&
                SHOW_CHARGE_INFO_ENABLED // delivery fee
              return (
                <tr
                  data-testid={id}
                  key={id}
                  className={cx({
                    [styles.total]:
                      id === 'total-order-remaining-amount' ||
                      id === 'total-order-amount'
                  })}
                >
                  <td className={styles.chargeInfo}>
                    {label}
                    {showServiceChargeInfoIcon && (
                      <button
                        type='button'
                        className={styles.infoButton}
                        onClick={() => setShowChargeModal(!showChargeModal)}
                      >
                        <span className='flex'>
                          <InfoIcon className={styles.infoImage} />
                        </span>
                      </button>
                    )}
                  </td>
                  <td>
                    <Dollars
                      amount={Number(amount) || 0}
                      renderWhenZero={
                        id === 'deliveryChargeTotal-amount' ? 'Free' : undefined
                      }
                    />
                  </td>
                </tr>
              )
            })}
          </tfoot>
        </table>
      </div>
    </>
  )
}

CartFooter.propTypes = {
  cart: PropTypes.object.isRequired,
  /** Override the default label when displaying a delivery charge line item */
  deliveryChargeLabel: PropTypes.node,
  showTotal: PropTypes.bool,
  showTip: PropTypes.bool,
  tip: PropTypes.number,
  showRoundUp: PropTypes.bool,
  roundUp: PropTypes.number
}
